import { Outlet, ScrollRestoration } from "react-router";
import { ProvideUser } from "./common/context/useUser";
import {
	isLastActiveContext,
	sameLastActiveContext,
} from "./common/utils/lastActiveContext.js";
import { isBoolean } from "./common/utils/isBoolean.js";
import { isValidLanguage } from "./common/utils/hooks/useLanguagePreference.js";
import { useSyncProfilePreference } from "./common/utils/hooks/useSyncProfilePreference.js";
import { DevToolsUnlockListener } from "./features/sidebar/DevToolsUnlockListener.js";

export const ProtectedApp = () => {
	useSyncProfilePreference(
		"lastActiveContext",
		isLastActiveContext,
		sameLastActiveContext,
	);
	useSyncProfilePreference("collapsedSidebar", isBoolean);
	useSyncProfilePreference("language", isValidLanguage);

	return (
		<>
			<ProvideUser>
				<DevToolsUnlockListener />
				<Outlet />
			</ProvideUser>
			<ScrollRestoration
				getKey={(location) => {
					return location.pathname;
				}}
			/>
		</>
	);
};
